/* eslint-disable array-bracket-newline */
/**
 * Selectable list of exchanges
 */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enums } from '@kattana-io/common';

import Image from '../../../../atoms/Image';
import Text from '../../../../atoms/Text';

import { decorateExchangeName } from '../../../../helpers/decorators';
import { actionUpdateModalParams } from '../../../../actions/modal_search';
import { IStore } from '../../../../reducers';
import {
  SearchSelectList,
  searchCexList,
  searchDexList,
  testnetsList,
} from '../../../../reducers/modal_search';

import shevronDown from '../../../../assets/images/shevron_down.svg';
import shevronUp from '../../../../assets/images/shevron_up.svg';

import gateio from '../../../../assets/images/exchanges/gateio.svg';
import binance from '../../../../assets/images/exchanges/binance.svg';
import bybit from '../../../../assets/images/exchanges/bybit_small.png';
import okx from '../../../../assets/images/exchanges/okx_internal.png';
import hitbtc from '../../../../assets/images/exchanges/hitbtc.png';
import uniswap from '../../../../assets/images/exchanges/uniswap.svg';
import pancakeswap from '../../../../assets/images/exchanges/pancakeswap.svg';
import sushiswap from '../../../../assets/images/exchanges/sushiswap.svg';
import traderjoe from '../../../../assets/images/exchanges/traderjoe.png';
import pangolin from '../../../../assets/images/exchanges/pangolin.svg';
import quickswap from '../../../../assets/images/exchanges/quickswap.svg';
import mdex from '../../../../assets/images/exchanges/mdex.svg';
import impossibleswap from '../../../../assets/images/exchanges/impossibleswap.svg';
import maiar from '../../../../assets/images/exchanges/maiar.svg';
import spookyswap from '../../../../assets/images/exchanges/spookyswap.svg';
import huobi from '../../../../assets/images/exchanges/huobi.svg';
import sunswap from '../../../../assets/images/exchanges/sunswap.png';
import justmoney from '../../../../assets/images/exchanges/justmoney.svg';
import kucoin from '../../../../assets/images/exchanges/kucoin.svg';
import kyber from '../../../../assets/images/exchanges/kyber.svg';
import biswap from '../../../../assets/images/exchanges/biswap.svg';
import okxdex from '../../../../assets/images/exchanges/okxdex.png';
import cherryswap from '../../../../assets/images/exchanges/cherryswap.svg';
import velodrome from '../../../../assets/images/exchanges/velodrome.png';

const imageMapping = {
  binance,
  bybit,
  hitbtc,
  gateio,
  okx,
  uniswap,
  pancakeswap,
  sushiswap,
  traderjoe,
  pangolin,
  quickswap,
  mdex,
  impossibleswap,
  maiar,
  spookyswap,
  huobi,
  sunswap,
  justmoney,
  kucoin,
  kyber,
  biswap,
  okxdex,
  cherryswap,
  velodrome,
};

const getClassName = (selectedChainsExchanges: string[], item: string) => {
  return selectedChainsExchanges.includes(item)
    ? 'tickers__panel__exchanges__exchange tickers__panel__exchanges__exchange--active'
    : 'tickers__panel__exchanges__exchange';
};

const ChainExchangeSelector = () => {
  const [popped, setPopped] = useState(true);
  const [chainsExchangesList, setChainsExchangesList] =
    useState<SearchSelectList>([...searchCexList, ...searchDexList]);
  const exchanges = useSelector((state: IStore) => state.modal_search.exchanges);
  const chains = useSelector((state: IStore) => state.modal_search.chains);
  const kind = useSelector((state: IStore) => state.modal_search.kind);

  const dispatch = useDispatch();

  useEffect(() => {
    if (kind === enums.ETickerKind.ALL) {
      setChainsExchangesList([...searchCexList, ...searchDexList]);
    }

    if (kind === enums.ETickerKind.CEX) {
      setChainsExchangesList([...searchCexList]);
    }

    if (kind === enums.ETickerKind.DEX) {
      setChainsExchangesList([...searchDexList]);
    }

    if (kind === 'testnet') {
      setChainsExchangesList([...testnetsList]);
    }
  }, [kind]);

  const onChainSelect = (item: string) => {
    if (chains.includes(item)) {
      const filtered = chains.filter((i) => i !== item);
      dispatch(actionUpdateModalParams({ chains: filtered }));
    } else {
      dispatch(actionUpdateModalParams({ chains: [...chains, item] }));
    }
  };

  const onExchangeSelect = (item: string) => {
    if (exchanges.includes(item)) {
      const filtered = exchanges.filter((i) => i !== item);
      dispatch(actionUpdateModalParams({ exchanges: filtered }));
    } else {
      dispatch(actionUpdateModalParams({ exchanges: [...exchanges, item] }));
    }
  };

  return (
    <div
      className={`tickers__panel__exchanges_container tickers__panel__exchanges_container--${
        popped ? 'popped' : 'small'
      }`}
    >
      <div className='tickers__panel__exchanges'>
        {chainsExchangesList.map(({ kind, item }) => {
          if (kind === enums.ETickerKind.CEX) {
            return (
              <div
                className={getClassName(exchanges, item)}
                key={item}
                onClick={() => onExchangeSelect(item)}
              >
                <Text size={14} data-qa={item}>
                  {decorateExchangeName(item)}
                </Text>
                <div className='img_wrapper'>
                  <Image src={(imageMapping as any)[item]} size='s' />
                </div>
              </div>
            );
          }

          return (
            <div
              className={getClassName(chains, item.getSymbol())}
              key={item.getSymbol()}
              onClick={() => onChainSelect(item.getSymbol())}
            >
              <Text size={14} data-qa={item.getTitle()}>
                {item.getTitle()}
              </Text>
              <div className='img_wrapper'>
                <Image
                  src={item.getImage()}
                  size='s'
                  className={`network_selector--${item.chain}`}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div
        className='tickers__panel__exchanges__toggler'
        onClick={() => setPopped(!popped)}
      >
        <Image src={popped ? shevronUp : shevronDown} size='s' />
      </div>
    </div>
  );
};

export default ChainExchangeSelector;
